export const SearchSortOptions = {
    Alphabetical: 'alphabetical',
    Created: 'created',
    Draft: 'draft',
    Featured: 'featured',
    HighPrice: 'highPrice',
    LowPrice: 'lowPrice',
    New: 'new',
    NewlyCreated: 'newlyCreated',
    Popular: 'popular',
    Trending: 'trending',
    Updated: 'updated',
} as const;

/**
 * @todo Merge with `SearchServiceSortOptions` in `@modules/search/type/api`.
 */
export type SearchSortOptions =
    (typeof SearchSortOptions)[keyof typeof SearchSortOptions];
